import './StickyFooter.scss'

export default function StickyFooter({ children, className }) {
	return <div className={`sticky-footer ${className}`}>{children}</div>
}
